import React,{ useState,useEffect } from "react";
import { Pagination } from "react-bootstrap";
import { PublicStrings } from "../../../../constants/Public-Strings";
const PaginationComponent = ({fetchList,paginationObject,nPages,page,numberOfItem}) => {
    const [previousPage, setPreviousPage] = useState(null);
    const [nextPage, setNextPage] = useState(null);
    const [firstUrl, setFirstUrl] = useState(null);
    const [lastUrl, setLastUrl] = useState(null);
  
      useEffect(()=>{
  
        setPreviousPage(paginationObject.previous_url ?? null);
        setNextPage(paginationObject.next_url);
        setFirstUrl(paginationObject.first_url);
        setLastUrl(paginationObject.last_url);
        
      },[paginationObject]);
    return (
      <div className="text-center p-3 row justify-content-between align-items-center ">
                        <div className="col-md-6 col-12 d-flex justify-content-center justify-content-sm-start  mb-3">
                          <h6 className="text-muted mb-0 ">
                            {"Articoli totali"}:{" "}
                            <span className="text-dark">{numberOfItem}</span>
                          </h6>
                          <h6 className="text-muted mb-0 mx-3">
                            {"Pagina"} <span className="text-dark">{page}</span> di{" "}
                            <span className="text-dark">{nPages}</span>
                          </h6>
                        </div>
                        <div className="col-md-6 col-12 d-flex justify-content-center justify-content-sm-end">
                          {
                            // products.length > 0?
                            true ? (
                              <nav aria-label="Pagination">
                                <Pagination>
                                  <Pagination.First
                                    onClick={() => {
                                      if (
                                        (firstUrl !== null) &
                                        (previousPage !== null)
                                      ) {
                                        fetchList(firstUrl);
                                      }
                                    }}
                                    disabled={
                                      (firstUrl !== null) &
                                      (previousPage !== null)
                                        ? false
                                        : true
                                    }
                                  ></Pagination.First>
                                  <Pagination.Item
                                    onClick={() => {
                                      if (previousPage !== null) {
                                        fetchList(previousPage);
                                      }
                                    }}
                                    disabled={
                                      previousPage !== null ? false : true
                                    }
                                  >
                                    {"Precedente"}
                                  </Pagination.Item>
                                  <Pagination.Item
                                    onClick={() => {
                                      if (nextPage !== null) {
                                        fetchList(nextPage);
                                      }
                                    }}
                                    disabled={nextPage !== null ? false : true}
                                  >
                                    {"Successivo"}
                                  </Pagination.Item>
                                  <Pagination.Last
                                    onClick={() => {
                                      if (
                                        (lastUrl !== null) &
                                        (nextPage !== null)
                                      ) {
                                        fetchList(lastUrl);
                                      }
                                    }}
                                    disabled={
                                      (lastUrl !== null) & (nextPage !== null)
                                        ? false
                                        : true
                                    }
                                  ></Pagination.Last>
                                </Pagination>
                              </nav>
                            ) : (
                              <></>
                            )
                          }
                        </div>
                      </div>
      
    )
  }

  export default PaginationComponent